'use client'
import ImageComponent from './ImageComponent'
import { getPortableTextComponents } from 'app/components/PortableTextComponents'
import { PortableText } from 'next-sanity'
import Link from 'next/link'
import { useState } from 'react'

export function Footer(props: any) {
  const { partnerLogos, language, footer } = props.data.footer || {}
  const [headingInView, setHeadingInView] = useState<string | undefined>()

  const handleInView = (inView: boolean, entry: IntersectionObserverEntry) => {
    if (inView) {
      setHeadingInView(entry.target.children[0].id)
    }
  }

  return (
    <footer className="border-t border-t-green-100 h-auto py-8">
      <div className="w-full mx-auto px-8">
        {partnerLogos && partnerLogos.length > 0 && (
          <div className="flex justify-center items-center flex-wrap gap-4 mb-8">
            {partnerLogos.map((logo: any) => {
              const maybeUrl = logo.logoHyperlinkUrl
              return (
                <div
                  title={logo.caption}
                  key={logo._key}
                  className="w-24 h-24 relative"
                >
                  {maybeUrl && (
                    <Link href={maybeUrl}>
                      <ImageComponent
                        className="object-contain w-24 h-24 rounded-md"
                        value={logo}
                      />
                    </Link>
                  )}
                </div>
              )
            })}
          </div>
        )}
        <div className="text-center w-full">
          <PortableText
            value={footer}
            components={getPortableTextComponents(handleInView)}
          />
        </div>
      </div>
    </footer>
  )
}
